import classNames from "classnames";
import React, { useEffect, useState } from "react";
import styles from "../../styles/setting.module.scss";
import { useUserInfo } from "../../context/ThemeContext";
import { Button, InputNumber, Popover } from "antd";
import {
  ExclamationCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import Image from "next/image";
import { useCommonData } from "../../layout/ELayout";
import PointsShareModal from "../common/PointsShareModal";

export default function Points(props: {
  userInfo: any;
  bindCard: (payType: string, payNum?: number) => void;
}) {
  const { userInfo, bindCard } = props;
  const [payType, setPayType] = useState<"ali" | "wx">("ali");
  const [payNum, setPayNum] = useState(50);
  const { commonData, changeCommonData } = useCommonData();
  const [shareOpen, setShareOpen] = useState(false);
  const onPayTypeChange = (value: "ali" | "wx") => {
    setPayType(value);
  };
  const onPayNumChange = (value: any) => {
    setPayNum(value);
  };
  const content = (
    <div
      style={{
        width: "70%",
        border: "1px dashed var(--border-color)",
        marginTop: 16,
        padding: 8,
        borderRadius: 16,
      }}
    >
      <div style={{ fontSize: 16, fontWeight: "bold", marginBottom: 8 }}>
        收费规则
      </div>
      <p>最低充值 50 元</p>
      <p>充值500-999，赠送5%额外积分</p>
      <p>充值1000以上，赠送10%额外积分</p>
    </div>
  );
  return (
    <div className={styles.wraper}>
      {/* <div className={styles.formbox}>
        <div className={styles.title}>免费生成次数：</div>
        <div>
          <div>{commonData.freeTimes}</div>
        </div>
      </div> */}
      <div className={styles.formbox}>
        <div className={styles.title}>账户积分余额：</div>
        <div>
          <div>{userInfo.points}</div>
        </div>
      </div>
      <div className={styles.formbox}>
        <div className={styles.title}>冻结积分：</div>
        <div>
          <div>{userInfo.frozen_points}</div>
        </div>
      </div>
      <div className={styles.formbox}>
        <div className={styles.title}>支付方式：</div>

        <div
          className={classNames(
            styles.payType,
            payType === "ali" ? styles.payActive : ""
          )}
          style={{ marginRight: "24px" }}
          onClick={() => onPayTypeChange("ali")}
        >
          <div className={styles.ali} />
          <span>支付宝</span>
        </div>
        <div
          className={classNames(
            styles.payType,
            payType === "wx" ? styles.payActive : ""
          )}
          onClick={() => onPayTypeChange("wx")}
        >
          <div className={styles.wx} />
          <span>微信</span>
        </div>
      </div>
      <div className={styles.formbox} style={{ alignItems: "start" }}>
        <div className={styles.title}>充值金额 ：</div>
        <div>
          <InputNumber
            min={50}
            max={1000000}
            style={{ width: 200 }}
            value={payNum}
            onChange={onPayNumChange}
            prefix="￥"
            suffix="元"
          />
          {payNum > 0 && (
            <div>
              预计可得{" "}
              {payNum >= 500
                ? payNum >= 1000
                  ? Math.floor(payNum * 1.1)
                  : Math.floor(payNum * 1.05)
                : payNum}{" "}
              积分
            </div>
          )}
        </div>
      </div>
      {/* <p className={styles.tips}>*请点击绑定跳转支付宝授权页面进行绑定</p> */}
      <div>
        <Button
          onClick={() => bindCard(payType, payNum)}
          type="primary"
          size="large"
        >
          支付
        </Button>
      </div>
      {content}
      <div className={styles.tip}>
        <ExclamationCircleOutlined />
        <span style={{ marginLeft: 8 }}>
          支持退款，扣除10%手续费,如需退款请
          <Popover
            placement="top"
            content={
              <Image
                src="/customer2.jpg"
                alt="Small decorative image"
                width={100} // 根据实际图片尺寸设置
                height={100}
              />
            }
          >
            <Button type="link">联系客服</Button>
          </Popover>
        </span>
      </div>
      <div style={{ position: "absolute", top: 16, right: 16 }}>
        <Button onClick={() => setShareOpen(true)} type="primary" size="large">
          分享邀请赚积分
        </Button>
      </div>
      <PointsShareModal open={shareOpen} onClose={() => setShareOpen(false)} />
    </div>
  );
}
